<template>
  <!-- eslint-disable max-len -->
  <svg
    :aria-label="ariaLabel"
    :height="height"
    :width="width"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      style="fill:#FFFFFF;"
      d="M41.3,50c0.5,0,1.4-0.1,2.4-0.3c-1.4,0.2-2.5,0.3-3.1,0.3c-0.2,0-0.5,0-0.7,0
      C40.4,50,40.9,50,41.3,50 M5.5,48.5c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.2-1.2-0.5-1.7-0.9C4.1,48,4.8,48.4,5.5,48.5 M6.7,48.9
      c-0.1,0-0.3,0-0.4-0.1C6.7,48.9,6.9,49,6.9,49c0.6,0.1,1.5,0.2,2.6,0.3c1,0.2,1.8,0.2,2.5,0.2h0.5h-0.9C11.1,49.5,9.5,49.3,6.7,48.9
       M1.6,45c0.1,0.2,0.2,0.4,0.3,0.6s0.2,0.3,0.3,0.5C2,45.7,1.8,45.4,1.6,45 M0.1,27.9c0,0.5,0.1,1.1,0.1,1.6l0.2,8.4
      c0-0.1,0-0.3,0-0.4l-0.2-8.9C0.2,28.4,0.2,28.1,0.1,27.9 M0,23.6v0.1c0,0.6,0,1.3,0,2.1C0,24.9,0,24.1,0,23.6 M0.2,7.3L0.2,7.3
      c0-0.1,0-0.2,0-0.4C0.3,7,0.3,7.1,0.2,7.3 M48,46.9c0.4-0.5,0.7-1.1,0.9-1.7c-0.4,0.9-0.9,1.7-1.5,2.4c-0.7,0.7-1.4,1.2-2.2,1.5
      C46.3,48.8,47.3,48,48,46.9 M49.9,40.5C49.9,40.4,49.9,40.4,49.9,40.5c0,0.5-0.1,1-0.2,1.5C49.9,41.4,49.9,40.9,49.9,40.5
       M22.7,49.3c-0.1,0-0.2,0-0.3,0c3.3,0.1,6,0.3,7.9,0.4C28.2,49.5,25.7,49.4,22.7,49.3 M16.2,0c-0.3,0-0.6,0-0.9,0c0.4,0,0.8,0,1.2,0
      H16.2 M49.8,14.4l0.1,5L49.8,14.4c0.1-1.2,0-2.6-0.1-3.9C49.8,11.9,49.9,13.2,49.8,14.4 M47.8,8.4c-0.3-2-1.2-3.7-2.6-5.1
      c-1.2-1-2.3-1.5-3.5-1.4c-2.4,0-4,0-4.7,0.1c-3.5,0.4-7.7,0.4-12.6,0.1c-3.6-0.2-6.3-0.4-8.1-0.5c-1.8-0.1-4,0-6.6,0.2
      C7.9,1.9,6.3,2.5,4.8,3.4c-1.9,1.3-2.9,3-3,5.2v1C2,10.7,2,12,1.8,13.3v24.6c0,1,0.1,2,0.2,2.9c0.1,1.4,0.6,2.8,1.4,4.2
      c0.6,1,1.3,1.6,2.3,2l1.2,0.3c2.1,0.4,3.7,0.6,5,0.6l4.7-0.1c5.3-0.2,10.5-0.1,15.5,0.4h8.1c0.9,0,2-0.1,3.3-0.4s2.2-0.9,2.9-2
      c0.6-0.8,1-1.6,1.2-2.6c0.3-1.6,0.5-2.8,0.5-3.6V14.9C48.3,12.7,48.1,10.4,47.8,8.4 M41.8,0.3c0.4,0,0.8,0,1.2,0.1
      c-0.5-0.1-1-0.1-1.4-0.1c-1.1,0-2,0-2.5,0c-0.2,0-0.5,0-0.7,0C39.3,0.3,40.4,0.3,41.8,0.3z"
    />
    <path
      style="fill:#FFFFFF;"
      d="M39.9,50c0.5,0,1,0,1.4,0c0.5,0,1.4-0.1,2.4-0.3c-1.4,0.2-2.5,0.3-3.1,0.3C40.4,50,40.1,50,39.9,50
       M5.5,48.5c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.2-1.2-0.5-1.7-0.9C4.1,48,4.8,48.4,5.5,48.5 M6.7,48.9c-0.1,0-0.3,0-0.4-0.1
      C6.7,48.9,6.9,49,6.9,49c0.6,0.1,1.5,0.2,2.6,0.3c1,0.2,1.8,0.2,2.5,0.2h0.5h-0.9C11.1,49.5,9.5,49.3,6.7,48.9 M2.2,46.1
      C2,45.8,1.8,45.4,1.6,45c0.1,0.2,0.2,0.4,0.3,0.6C2,45.7,2.1,45.9,2.2,46.1 M0.1,27.9c0,0.5,0.1,1.1,0.1,1.6l0.2,8.4
      c0-0.1,0-0.3,0-0.4l-0.2-8.9C0.2,28.4,0.2,28.1,0.1,27.9 M0,23.6v0.1c0,0.6,0,1.3,0,2.1C0,24.9,0,24.1,0,23.6 M0.3,6.9
      c0,0.1,0,0.3,0,0.4v0.1C0.3,7.2,0.3,7,0.3,6.9 M48.9,45.3c-0.4,0.9-0.9,1.6-1.5,2.3c-0.7,0.7-1.4,1.2-2.2,1.5
      c1.1-0.4,2.1-1.2,2.8-2.3C48.3,46.4,48.6,45.9,48.9,45.3 M49.9,40.4c0,0.5-0.1,1.1-0.2,1.6C49.9,41.4,49.9,40.9,49.9,40.4L49.9,40.4
       M22.7,49.3c-0.1,0-0.2,0-0.3,0c3.3,0.1,6,0.3,7.9,0.4C28.2,49.5,25.7,49.4,22.7,49.3 M16.2,0c-0.3,0-0.6,0-0.9,0c0.4,0,0.8,0,1.2,0
      H16.2 M49.8,14.4l0.1,5L49.8,14.4c0.1-1.2,0-2.6-0.1-3.9C49.8,11.9,49.9,13.2,49.8,14.4 M43.1,0.4c-0.5-0.1-1-0.1-1.4-0.1
      c-1.1,0-2,0-2.5,0c-0.2,0-0.5,0-0.7,0c0.9,0,2,0,3.4,0C42.3,0.3,42.7,0.3,43.1,0.4z"
    />
    <path
      style="fill:#231F20;"
      d="M50,36.6c0-1.9,0-3.4,0-4.5V19.4l-0.1-5c0-1.3,0-2.5-0.1-3.9l-0.2-1.9c0-0.2-0.1-0.5-0.1-0.7
      c0-0.1-0.1-0.3-0.1-0.4c-0.3-1.9-1.2-3.5-2.5-4.9l-0.2-0.2l0,0c-0.1-0.1-0.2-0.2-0.2-0.2c-0.2-0.2-0.4-0.3-0.6-0.5l-2-1l-0.4-0.1
      c-0.4-0.1-0.8-0.1-1.2-0.1c-1.4,0-2.6,0-3.4,0c-0.8,0-1.4,0.1-1.7,0.1C33.8,1,30,1.1,25.8,0.8c-0.9,0-1.9-0.1-3.2-0.1l-5.5-0.4
      c-0.4,0-0.8,0-1.2,0l-4.3,0.1c-0.5,0-0.9,0.1-1.4,0.1c-0.9,0-1.9,0.2-3.1,0.6C5.4,1.6,3.9,2.5,2.7,3.8C1.8,4.8,1.2,5.9,1,7.1
      c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2L0.9,9.7c0,0.3,0,0.6,0,0.9v13.2c0,0.5,0,1.2,0,2.2c0,0.1,0,0.2,0,0.2c0,0.7,0,1.3,0.1,1.8
      c0,0.2,0.1,0.4,0.1,0.6l0.2,8.9c0,0.2,0,0.3,0,0.4V40c0,0.1,0,0.1,0,0.2l1.1,4.7C2.6,45.3,2.8,45.7,3,46l1.3,1.5
      c0.5,0.4,1.1,0.7,1.7,0.9c0.1,0,0.2,0.1,0.2,0.1c0.3,0.1,0.6,0.2,0.8,0.2c0.2,0.1,0.3,0.1,0.4,0.1c2.7,0.4,4.4,0.6,4.9,0.6h0.9
      l5.3-0.1c2.5-0.1,4-0.1,4.5-0.1c0.1,0,0.2,0,0.3,0c3,0.1,5.5,0.2,7.6,0.4h0.3c0.1,0,0.2,0,0.2,0c0.2,0,0.5,0,0.7,0l8.3,0.1
      c0.3,0,0.5,0,0.7,0c0.7,0,1.7-0.1,3.1-0.3c0.1,0,0.2,0,0.2,0c0.4-0.1,0.8-0.2,1.1-0.4c0.8-0.3,1.5-0.8,2.2-1.5
      c0.6-0.7,1.1-1.5,1.5-2.3v-0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.1,0-0.2c0.3-0.9,0.5-1.8,0.6-2.7c0.1-0.5,0.2-1,0.2-1.6
      C50,39,50,37.7,50,36.6 M41.6,1.8c1.2,0,2.4,0.4,3.5,1.4c1.5,1.4,2.3,3.1,2.6,5.1c0.3,2.1,0.4,4.3,0.4,6.7v24.7c0,0.8-0.2,2-0.5,3.6
      c-0.2,1-0.6,1.9-1.2,2.6c-0.7,1.1-1.7,1.7-2.9,2c-1.3,0.3-2.4,0.4-3.3,0.4h-8.1c-5-0.5-10.2-0.7-15.5-0.4L11.9,48
      c-1.3,0-2.9-0.2-5-0.6l-1.2-0.3c-1-0.4-1.7-1-2.3-2c-0.8-1.4-1.3-2.8-1.4-4.2C1.9,40,1.8,39,1.8,38V13.4c0.1-1.3,0.1-2.6,0-3.7v-1
      c0.1-2.2,1.1-4,3-5.2C6.3,2.6,7.9,2,9.7,1.9c2.6-0.2,4.8-0.3,6.6-0.2s4.5,0.3,8.1,0.5c4.9,0.3,9.1,0.2,12.6-0.1
      C37.6,1.9,39.2,1.8,41.6,1.8z"
    />
    <path
      style="fill:#6EC8C6;"
      d="M29.1,24.3V12.5l-5,10.4l-7.9-1.6l4.8,6.8l-6.1,8.4l9.4-3l4.7,9l0.2-11l7.7-3.2L29.1,24.3 M12,10.7
      l-2-4.2v4.8l-3.1,1.5l3.1,1.3v4.4l1.9-3.6l3.8,1.2l-2.4-3.4l1.9-2.7L12,10.7 M35.2,21.4l2.7-1.5l1.9,2.4l-0.1-3.2l2.3-0.9l-2.3-0.9
      l0.4-3.5l-2,3l-2.6-0.3l1.4,2.1L35.2,21.4z"
    />
    <path
      id="CertificateBtn_0_Layer0_0_1_STROKES"
      style="fill:none;stroke:#231F20;stroke-miterlimit:10;"
      d="M40.2,13.7l-0.4,3.5
      l2.3,0.9L39.8,19l0.1,3.2L38,19.8l-2.7,1.5l1.8-2.8l-1.4-2.1l2.6,0.3L40.2,13.7z M10,6.5l2,4.2l3.2-0.6l-1.9,2.7l2.4,3.4L11.9,15
      L10,18.6v-4.4l-3.1-1.3l3.1-1.5L10,6.5z M29.1,12.5l-5,10.4l-7.9-1.6l4.8,6.8l-6.1,8.4l9.4-3l4.7,9l0.2-11l7.7-3.2l-7.8-3.8
      C29.1,24.5,29.1,12.5,29.1,12.5z"
    />
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon],
  props: {
    ariaLabel: {
      type: String,
      default: 'Certificate'
    }
  }
};
</script>
